module.exports = __webpack_public_path__ + "img/scan-blue-grey.6af2d533.svg";